import Api from  "@/services/AxiosAPI";

export default {


  creditcount(customerid) {
    return Api.getData('customer/' + customerid)
      .then(responses => {
        return responses
      });


  }
}